import ProductPageShell from "@/components/ProductPageShell";
import { Users, Building2, Calendar } from "lucide-react";

export default function Campus() {
  const visual = (
    <div className="relative aspect-square max-w-sm mx-auto w-full">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-amber-500/15 via-[#0F1D40] to-[#14264F] border border-amber-500/20 overflow-hidden">
        <div className="absolute inset-6 grid grid-cols-3 gap-2 opacity-70">
          {Array.from({ length: 9 }).map((_, i) => (
            <div key={i} className="rounded-lg bg-amber-500/10 border border-amber-500/20 flex items-center justify-center">
              <Building2 className="w-5 h-5 text-amber-400/70" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <ProductPageShell
      product="campus"
      label="Operon Campus"
      accent="amber"
      kicker="Operon Campus · For science-park operators"
      title="Run your science park, in one place."
      lede="A platform for managing the day-to-day of a thriving science park: tenants, events, resources and visitors — connected to the UK therapeutics ecosystem Operon already sits inside."
      bullets={[
        { title: "Tenant & resident directory", body: "A living record of the companies in your park, what they\u2019re working on and who to reach — searchable, shareable and always up to date." },
        { title: "Events & visitor flows", body: "Run on-site events, coordinate tours and track who visited whom — so nothing great happens quietly in a corner." },
        { title: "Shared resources & bookings", body: "Labs, meeting rooms, equipment: one simple way to book, see availability and avoid the clash on the Monday morning." },
      ]}
      visual={visual}
    />
  );
}
